/**
 * Enum of tab names used in Settings.
 */
export enum SettingsTab {
  Account = 'account',
  Admins = 'admins',
  CustomFields = 'customFields',
  Datasets = 'datasets',
  Masks = 'masks',
  Devices = 'devices',
  Import = 'import',
  Templates = 'templates'
}
